import { useEffect } from 'react';

export function useMeta({ title, favicon }) {
  useEffect(() => {
    // Título de la pestaña
    if (title) document.title = title;

    // Favicon
    if (favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = favicon;
      link.type = favicon.endsWith('.svg') ? 'image/svg+xml' : 'image/x-icon';
    }
  }, [title, favicon]);
}
